import type {ButtonProps} from '@Components/button';

export interface DownloadPanelUpsellingDialogData {
  type: DownloadPanelUpsellingTypes;
  GAEventId?: string;
  thumbURL: string;
  text: string;
  buttonProps: ButtonProps;
  isHidden?: boolean;
  hasAiButtonType?: boolean;
}

export const ENABLED_DOWNLOAD_UPSELLING_DIALOG_NUMBER = 10;

export const AI_CHAT_UPSELLING_INDEX = 1;

export enum DownloadPanelUpsellingTypes {
  PUBLISH = 'publish',
  CONTENT_PLANNER = 'content_planner',
  EVENT_GENERAL = 'event_general',
  QR_CODE_GENERAL = 'qr_code_general',
  EMAIL_MAKER = 'email_maker',
  AI_BACKGROUND_REMOVE = 'ai_remove_bg',
  AI_IMAGES = 'ai_image',
  MOBILE_APP = 'mobile_app',
  ANIMATIONS = 'animations',
  BRAND_KIT = 'brand_kit',
  SOCIAL_MEDIA = 'social_media',
  SOCIAL_MEDIA_SIZE = 'social_media_size',
  EVENT_CALENDAR = 'event_calendar',
  EVENTS = 'events',
  DIGITAL_SIGNAGE_MENU = 'digital_signage',
  QR_CODES_MENU = 'qr_codes_menu',
  EMAIL_AI_WRITER = 'email_ai_writer',
  AI_IMAGE_REMOVE_BACKGROUND = 'ai_image_remove_background',
  AI_VIDEO_REMOVE_BACKGROUND = 'ai_video_remove_background',
  AI_SUBTITLES = 'ai_subtitles',
  AI_VOICE = 'ai_voice',
  RESIZE = 'resize',
  STICKERS = 'stickers',
  TIMELINE_VIDEO = 'timeline_video',
  TIMELINE_AUDIO = 'timeline_audio',
  BUSINESS_PROFILES = 'business_profiles',
  MENU_MAKER = 'menu_maker',
  TEAMS = 'teams',
  UPLOAD_FONTS = 'upload_fonts',
  SPELLCHECK = 'spellcheck',
  AI_CHAT = 'ai_chat',
}
